import { createContext, useContext, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import ConsultationForm from "@/components/ConsultationForm";

const ConsultationContext = createContext({ open: () => {} });

export const useConsultation = () => useContext(ConsultationContext);

export function ConsultationProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return (
    <ConsultationContext.Provider value={{ open }}>
      {children}
      <AnimatePresence>
        {isOpen && (
          <div className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center sm:p-6" data-testid="consultation-modal">
            <motion.div
              className="absolute inset-0 bg-stone-900/50 backdrop-blur-sm"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={close}
            />
            <motion.div
              className="relative w-full sm:max-w-lg bg-white border border-amber-600/25 sm:rounded-xl rounded-t-2xl p-6 sm:p-8 max-h-[92vh] overflow-y-auto shadow-2xl"
              initial={{ opacity: 0, y: 60 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 60 }}
              transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
            >
              <button onClick={close} aria-label="Close" data-testid="consultation-modal-close" className="absolute top-4 right-4 text-stone-400 hover:text-amber-700 transition-colors duration-200">
                <X className="w-5 h-5" />
              </button>
              <p className="text-xs uppercase tracking-[0.25em] font-semibold text-amber-700 mb-2">Free In-Home Consultation</p>
              <h3 className="font-display text-2xl text-stone-900 mb-6">Let's design your floor</h3>
              <ConsultationForm formId="modal-consultation" onSuccess={close} />
            </motion.div>
          </div>
        )}
      </AnimatePresence>
    </ConsultationContext.Provider>
  );
}
